import { ResetPasswordComponent } from './../reset-password/reset-password.component';
import { LoginService } from './../../../../core/services/login.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LogoutService } from './../../../../core/services/logout.service';
import { LoginData } from '../../../../core/models/login-data';
import { OtpComponent } from './../otp/otp.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { SlsService } from 'src/app/core/services/sls.service';
import { ToastService } from 'src/app/core/toast.service';
import { DetailsService } from '../../services/details.service';
import * as _moment from 'moment';
import { RenewRequestComponent } from 'src/app/modules/sign-up/components/renew-request/renew-request.component';
import { IncomProfComponent } from 'src/app/modules/sign-up/components/incom-prof/incom-prof.component';
import { NextTabService } from 'src/app/modules/sign-up/services/next-tab.service';
import { SignupPlanPaymentsComponent } from '../../../sign-up/components/signup-plan-payments/signup-plan-payments.component';
import { SubscriptionPlansService } from '../../services/subscription-plans.service';
import { ProfileListingComponent } from 'src/app/modules/profile/pages/profile-listing/profile-listing.component';
import { Overlay } from '@angular/cdk/overlay';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  submitted = false;
  /* --------------------------------- FIELDS -------------------------------- */
  loginForm: FormGroup;
  signUpForm: FormGroup;
  forgotPwdForm: FormGroup;
  passwordShow = false;
  userSubscriptions: any;
  isAnimate: true;
  //emailRegex = new RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
  passwordRegex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/);
  signInShow = true;
  // signUpShow = false;
  forgotPwdShow = false;
  user: any;
  PaidRecords = [];
  currentPlan: any;
  userDetails:any;
  resData:any;
  forgotData = {
    details:{
      email:null,
      type:null
    }
  }
  
  emailRegex = new RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  phoneRegex = new RegExp(/^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/);
  

  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialogRef: MatDialogRef<LoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
    private _fb: FormBuilder,
    private _dialog: MatDialog,
    private authService: AuthService,
    private sls: SlsService,
    private toast: ToastService,
    private logoutService: LogoutService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private detailsService: DetailsService,
    private nextTabService:NextTabService,
    private router : Router,
    private subscriptionPlansService: SubscriptionPlansService,
    private overlay: Overlay
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit() {   

    this.loginForm = this._fb.group({
      type: [''],
      emailOrPhone: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
      password: [null, [Validators.required]],
    });
    this.signUpForm = this._fb.group({
      name: [null, [Validators.required]],
      phoneNo: [null, [Validators.required]],
      emailId: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
      password: [null, [Validators.required, Validators.pattern(this.passwordRegex)]],
    });
    this.forgotPwdForm = this._fb.group({
      emailRec: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
      type: [null, [Validators.required]],
      // confPassword: [null, [Validators.required, Validators.pattern(this.passwordRegex)]],
    });
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  dialogClose() {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutUp");
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
  viewPassword() {
    this.passwordShow = !this.passwordShow;
  }
  // signUp(): void {
  //   this.signInShow = !this.signInShow;
  //   this.signUpShow = !this.signUpShow;
  // }
  forgotPwd() {
    this.signInShow = !this.signInShow;
    this.forgotPwdShow = !this.forgotPwdShow;
    this.submitted = false;
  }
   logIn() {
     this.submitted = false;
    this.signInShow = true;
   this.forgotPwdShow = !this.forgotPwdShow;
  }
  
  otp(): void {
    this._dialog.open(OtpComponent, {
      width: '30%',
      panelClass: 'custom-modal'
    })
  }
 async resetPassword() {
  this.submitted = true;
  console.log(this.forgotPwdForm.invalid);
  if (this.forgotPwdForm.invalid) {
    this.toast.openSnackBar('Please enter valid details');
    return;
  }

  console.log(this.forgotPwdForm.value)

  this.spinner.show()

  this.forgotData.details.email = this.forgotPwdForm.value.emailRec
  this.forgotData.details.type = this.forgotPwdForm.value.type

 await this.authService.forgotPassword(this.forgotData).then(data=>{
   this.resData = data
   console.log(this.resData)
   if(this.resData==undefined){
    console.log('failed');
    this.spinner.hide()
    this.toast.openSnackBar(
      'You Failed'
    );
   }else{
    this.spinner.hide()
    this._dialog.open(ResetPasswordComponent, {
      width: '25%',
      panelClass: 'custom-modal'
    })

   }
 })



  }
  profilePending(): void {
    this._dialog.open(OtpComponent, {
      width: '30%',
      panelClass: 'custom-modal'
    })
  }
  /* --------------------------------- GETTERS --------------------------------- */
  get type(): AbstractControl {
    return this.loginForm.get('type');
  }
  get emailOrPhone(): AbstractControl {
    return this.loginForm.get('emailOrPhone');
  }
  get password(): AbstractControl {
    return this.loginForm.get('password');
  }
  get name(): AbstractControl {
    return this.signUpForm.get('name');
  }
  get emailId(): AbstractControl {
    return this.signUpForm.get('emailId');
  }
  get phoneNo(): AbstractControl {
    return this.signUpForm.get('phoneNo');
  }
 get emailRec() :AbstractControl{
  return this.forgotPwdForm.get('emailRec');

 }
  // get confPassword(): AbstractControl {
  //   return this.forgotPwdForm.get('confPassword');
  // }
  popupClose() {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutUp");
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }


  async login() {
    this.submitted = true;

    if (this.loginForm.invalid) {
      this.toast.openSnackBar('Please enter valid details');
      return;
    }else{
      this.popupClose();
    }

    this.spinner.show();

    try {
      const success: LoginData = await this.authService.login(this.loginForm.value)
      this.sls.set('loginData', success);
      const response = this.logoutService.reset();
      this.loginService.isLoggedInSubject.next(true);      
      this.spinner.hide();

      setTimeout(function() { 
        this.toast.openSnackBar('Logged in successfully'); 
      }, 2000);
     
      this.user = this.loginService.getLoginData();
      //console.log(this.user)
      localStorage.setItem('logInfo', JSON.stringify(this.user));
      this.popupClose();
      if(this.user.type == "SUPPLIER"){


        this.nextTabService.getUserSupplier(this.user.id).subscribe(data=>{
          console.log('mysupp-->',data);
          this.userDetails = data

          this.subscriptionPlansService.getSubPlanById(this.userDetails.id).subscribe(data2 => {
              console.log('User Sub info --->', data2);
          });

     

        })

        
      }

      if(this.user.type == "PRACTICE"){

        this.nextTabService.getUserPractice(this.user.id).subscribe(data=>{
          console.log(data)
          this.userDetails = data

       
            if(this.userDetails.length == 0){
              
              this._dialog.open(IncomProfComponent, {
                width: '30%',
                scrollStrategy: this.overlay.scrollStrategies.noop(),
                panelClass: ['custom-modal', 'animate__animated', 'animate__slideInLeft'],
                disableClose: true,
                data: this.userDetails
              });
            }
          
        })

      }

      if(this.user.type == "PROFESSIONAL"){
        console.log('User Id --->', this.user.id)
        this.nextTabService.getUserProf(this.user.id).subscribe(data=>{
          console.log('User Info-->',data)
          this.userDetails = data

          if(this.userDetails.length == 0){
            console.log('44444')

            this._dialog.open(IncomProfComponent, {
              width: '30%',
              scrollStrategy: this.overlay.scrollStrategies.noop(),
              panelClass: ['custom-modal', 'animate__animated', 'animate__slideInDown'],
              disableClose: true,
              data: this.userDetails
            });

          }

        })

      }

      //return
      this.detailsService.getuserSub(this.user.id).subscribe(data => {
        //console.log('User Sub--->',data)
        this.userSubscriptions = data

        this.userSubscriptions = this.userSubscriptions.sort(function (a, b) {
          //return b.created_at.getTime() - a.created_at.getTime();
          var c: any = new Date(a.created_at);
          var d: any = new Date(b.created_at);
          return d - c;
        });

        if(this.userSubscriptions.length){

          this.currentPlan = this.userSubscriptions[0]
          const mm = _moment(this.currentPlan.expires_at).toDate().getTime()
          console.log(this.currentPlan.expires_at.toLocaleString())
          console.log(mm)
          if (new Date().getTime() > mm) {
            this._dialog.open(RenewRequestComponent, {
              width: '30%',
              panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
              disableClose: true
            })
          }

        }
        this.router.navigate(['/profile/detail'])
        // this.router.navigate(['/profile/my-dashboard'])
      })
    } catch (error) {
      console.log(error);
      this.spinner.hide();
      this.toast.openSnackBar('Please enter valid details');
    }
  }
  
  goToSignUp(ev: MouseEvent){
    ev.preventDefault();
    this._dialogRef.close('subscriptions');
  }


 

}
